// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18u01wug{margin-left:auto}
._19pkidpf{margin-top:0}
._1bsbys9h{width:5pc}
._1e0c1ule{display:block}
._2hwx1wug{margin-right:auto}
._otyr1ejb{margin-bottom:var(--ds-space-300,24px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/node_modules/@atlaskit/smart-card/dist/esm/view/RelatedLinksModal/views/errored/error-svg/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,gBAAgB;AAC3B,WAAW,YAAY;AACvB,WAAW,SAAS;AACpB,WAAW,aAAa;AACxB,WAAW,iBAAiB;AAC5B,WAAW,sCAAsC","sourcesContent":["._18u01wug{margin-left:auto}\n._19pkidpf{margin-top:0}\n._1bsbys9h{width:5pc}\n._1e0c1ule{display:block}\n._2hwx1wug{margin-right:auto}\n._otyr1ejb{margin-bottom:var(--ds-space-300,24px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
